<template>
    <div id="Calculator" class="container rounded">
        <div class="row rounded-top">
        <div class="col">
            {{ translate.inputtext }}
            </div>
        <div class="col input-group mb-1">
            <input class="form-control"
             v-model="mass" type="text" :placeholder="translate.peryear" />
            </div>
        </div>
        <div class="row"><div class="col">{{ translate.requerments }}</div></div>
        <div class="row"><div class="col">{{ result[16] }}</div></div>
        <div class="row">
        <div class="col">{{ translate.resource }}</div>
        <div class="col">{{ translate.count }}</div>
        <div class="col">{{ translate.sum }}</div>
        </div>
        <div class="row">
        <div class="col">{{ translate.size }}</div>
        <div class="col">{{ Math.round(result[1]) }} га</div>
        <div class="col">{{ Math.round(result[8]) }}тг, ${{ Math.round(result[18]) }}
            <div class="row">
                <div class="col">{{ translate.with }}</div>
        </div></div>
        </div>
        <div class="row"><div class="col">{{ translate.firstpay }}</div></div>
        <div class="row">
        <div class="col">{{ translate.ship }}</div>
        <div class="col">{{ result[2] }} {{ translate.pieces }}</div>
        <div class="col">{{ result[9] }}</div>
        </div>
        <div class="row">
        <div class="col">{{ translate.fishitems }}</div>
        <div class="col">{{ translate.parts }}</div>
        <div class="col">{{ result[10] }}</div>
        </div>
        <div class="row"><div class="col">{{ translate.currentpay }}</div></div>
        <div class="row">
        <div class="col">{{ translate.fisheat }}</div>
        <div class="col">{{ result[4] }} кг.</div>
        <div class="col">{{ result[11] }}</div>
        </div>
        <div class="row">
        <div class="col">{{ translate.watt }}</div>
        <div class="col">{{ result[5] }} кВт.</div>
        <div class="col">{{ result[12] }}</div>
        </div>
        <div class="row">
        <div class="col">{{ translate.fishplant }}</div>
        <div class="col">{{ result[6] }} {{ translate.pieces }}</div>
        <div class="col">{{ result[13] }}</div>
        </div>
        <div class="row"><div class="col">{{ translate.economic }}</div></div>
        <div class="row">
        <div class="col">{{ translate.revenue }}</div>
        <div class="col">{{ result[7] }} {{ translate.pertonn }}</div>
        <div class="col">{{ result[14] }}</div>
        </div>
        <div class="row">
        <div class="col">{{ translate.gross }}</div>
        <div class="col">{{ translate.totalcost }}</div>
        <div class="col">{{ result[15] }}</div>
        </div>
        <div class="row"><div class="col">{{ translate.comment }}</div>
        </div>
        <div class="row rounded-bottom"><div class="col">{{ regionText }}</div></div>
        </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      ru: {
        inputtext: 'Введите планируемый объем производства рыб',
        peryear: 'тонн в год',
        requerments: 'Необходимые условия',
        resource: 'Показатель',
        count: 'Количество',
        sum: 'Сумма, тенге',
        size: 'Площадь водоема',
        with: 'из них',
        firstpay: 'Первоначальные затраты',
        ship: 'Лодка резиновая',
        pieces: 'шт.',
        fishitems: 'Рыболовный инвентарь',
        parts: 'комплект.',
        currentpay: 'Текущие затраты',
        fisheat: 'Корма',
        watt: 'Электропотребление',
        fishplant: 'Рыбопосадочный материал',
        economic: 'Экономические расчеты',
        gross: 'Прибыль',
        pertonn: 'тонн по 600 тг/кг',
        revenue: 'Выручка',
        totalcost: 'При себестоимости производства 60%',
        comment: 'Рекомендации по производству рыбной продукции',
        text: '«При планировании прудового хозяйства следует учитывать необходимость проведения земляных работ для улучшения состояния прудов и эффективной работы хозяйства, а также проведение мелиорации для улучшения кормовой базы»',
      },
      kz: {
        inputtext: 'Жоспар бойынша өндірілетін балық мөлшерін жазыңыз',
        peryear: 'жылына тонна',
        requerments: 'Қажетті жағдай',
        resource: 'Көрсеткіш',
        count: 'Саны',
        sum: 'Сомасы, теңге',
        size: 'Су айдынының ауданы',
        with: 'оның ішінде',
        firstpay: 'Алғашқы шығындар',
        ship: 'Резеңке қайық',
        pieces: 'дана.',
        fishitems: 'Балық аулайтын құрал-жабдық',
        parts: 'жиынтық',
        currentpay: 'Ағымды шығымдар',
        fisheat: 'Жемдер',
        watt: 'Электр қуатып пайдалану',
        fishplant: 'Отырғызылатын балық материалы',
        economic: 'Экономикалық есептер',
        gross: 'Пайда',
        pertonn: 'тонна 600 тг/кг бойынша',
        revenue: 'Табыс',
        totalcost: 'Өндірістің өзіндік құны 60% болғанда',
        comment: 'Балық өнімін өндіру барысындағы ұсыныстар',
        text: 'Тоған шаруашылығын жоспарлау барысында, шаруашылық жұмысының тиімділігін арттыру үшін және тоғандардың күйін жақсарту үшін жерде жасалатын жұмыстарды орындау қажет, қоректік базаны жақсарту үшін мелиорациялық жұмыстарды жүргізу керек.',
      },
      mass: null,
      result: {
        1: 10,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
        7: 0,
        8: 0,
        9: 0,
        10: 0,
        11: 0,
        12: 0,
        13: 0,
        14: 0,
        15: 0,
        16: '',
        17: 'текстовый материал (ссылка на соответствующую область Казахстана)',
        18: 0,
      },
    };
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    mass(newMass, oldMass) {
      const lang = this.$store.state.calc.currentLocale;
      switch (true) {
        case (newMass <= 50):
          this.result = {
            1: 2 * newMass,
            2: 2,
            3: 1,
            4: newMass * 100,
            5: 3500,
            6: newMass * 20000,
            7: newMass,
            8: 170000 + 250000 + (newMass * 100 * 200) + 85500 + (newMass * 20000),
            9: 170000,
            10: 250000,
            11: newMass * 100 * 200,
            12: 85500,
            13: newMass * 20000,
            14: newMass * 600000,
            15: newMass * 600000 * 0.6,
            16: this[lang].text,
            17: 'текстовый материал (ссылка на соответствующую область Казахстана)',
            18: (170000 + 250000 + (newMass * 100 * 200) + 85500 + (newMass * 20000))
             / this.getUSD(),
          };
          break;
        case (newMass <= 100):
          this.result = {
            1: 2 * newMass,
            2: 4,
            3: 2,
            4: newMass * 100,
            5: 7000,
            6: newMass * 20000,
            7: newMass,
            8: 340000 + 500000 + (newMass * 100 * 200) + 171000 + (newMass * 20000),
            9: 340000,
            10: 500000,
            11: newMass * 100 * 200,
            12: 171000,
            13: newMass * 20000,
            14: newMass * 600000,
            15: newMass * 600000 * 0.6,
            16: this[lang].text,
            17: 'текстовый материал (ссылка на соответствующую область Казахстана)',
            18: (340000 + 500000 + (newMass * 100 * 200) + 171000 + (newMass * 20000))
             / this.getUSD(),
          };
          break;
        case (newMass > 100):
          this.result = {
            1: 2 * newMass,
            2: 6,
            3: 4,
            4: newMass * 100,
            5: 9000,
            6: newMass * 20000,
            7: newMass,
            8: 510000 + 1000000 + (newMass * 100 * 200) + 219000 + (newMass * 20000),
            9: 510000,
            10: 1000000,
            11: newMass * 100 * 200,
            12: 219000,
            13: newMass * 20000,
            14: newMass * 600000,
            15: newMass * 600000 * 0.6,
            16: this[lang].text,
            17: 'текстовый материал (ссылка на соответствующую область Казахстана)',
            18: (510000 + 1000000 + (newMass * 100 * 200) + 219000 + (newMass * 20000))
            / this.getUSD(),
          };
          break;
        default:
          break;
      }
    },
  },
  computed: {
    regionText() {
      const lang = this.$store.state.calc.currentLocale;
      const region = this.$store.state.calc.selectedRegion;
      return this.$store.state.calc.textRegion[lang][region];
    },
    translate() {
      const lang = this.$store.state.calc.currentLocale;
      return this[lang];
    },
  },
  created() {
    this.getCurrency();
    this.$say('4.ogg');
  },
  methods: {
    ...mapActions('calc', ['getCurrency']),
    getUSD() {
      return this.$store.state.calc.USD;
    },
    round_to_precision(x, precision) {
      const y = +x + (precision === undefined ? 0.5 : precision / 2);
      return y - (y % (precision === undefined ? 1 : +precision));
    },
  },


};
</script>
<style scoped>
#Calculator {
    background-color: #22a6de;
    margin: 0 auto;
}
#Calculator div.row {
    border-top: solid #bababa 1px;
    text-align: center;
}
#Calculator div.col {
    border-left: solid #bababa 1px;
    text-align: center;
}
.row {
  flex-wrap: nowrap !important;
}
</style>
